import { render, staticRenderFns } from "./MitrexCalculator.vue?vue&type=template&id=656cb6fd&scoped=true"
import script from "./MitrexCalculator.vue?vue&type=script&lang=js"
export * from "./MitrexCalculator.vue?vue&type=script&lang=js"
import style0 from "./MitrexCalculator.vue?vue&type=style&index=0&id=656cb6fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656cb6fd",
  null
  
)

export default component.exports